import React, { useState } from "react";
import TitleChart from "../components/TitleChart";
import { Box, Button, Fade, Grid, IconButton, useTheme } from "@mui/material";
import TabChartFilter from "../components/TabChartFilter";
import useReportOfSalesExpertsContainer from "./useReportOfSalesExpertsContainer";
import ChartRenderer from "./ChartRenderer";
import TotalChart from "../TotalChart";
import useDeviceType from "../../../global/Hooks/useDeviceType";
import Month from "../components/Month";
import YearsDrop from "../components/YearsDrop";
import useCheckDisplayChart from "../components/useCheckDisplayChart";
import DySelectBas from "../../../../General/Components/DySelect/DySelectBas";
import { enumsRender } from "../../../OrganizationDefinitions/CreateUserAccount/StaticFiles";
import { useGetEnumsValue } from "../../../OrganizationDefinitions/CreateUserAccount/Hooks";
import ClearIcon from "@mui/icons-material/Clear";
import { FilterIcon } from "lucide-react";
import PersianDatePicker from "../components/PersianDatePicker";
import FilterHandler from "../components/FilterHandler";

function SalesExpertChart() {
  const theme = useTheme().palette.mode;

  const { data: enumsData } = useGetEnumsValue(["PurchaseInvoiceType"]);
  const { action, values } = useReportOfSalesExpertsContainer();
  const {
    chartFilter,
    dataLineChart,
    salseExperts,
    total,
    month,
    year,
    purchaseInvoiceType,
  } = values;
  const { tabHandler, setMonth, setYear, setPurchaseInvoiceType } = action;
  const deviceType = useDeviceType();
  /* -------------------------------- Accrdion -------------------------------- */

  const chartKey = "saleExpertChart";
  const { displayChart } = useCheckDisplayChart(chartKey);
  const [filter, setFilter] = useState(false);

  return (
    <>
      {displayChart ? (
        <>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginBottom: "4px",
              flexWrap: "nowrap",
              overflowX: "auto",
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                width: "40%",
                display: "flex",
                justifyContent: "flex-start",
                minWidth: 200,
              }}
            >
              <TitleChart label={"کارشناسان فروش"} chartKey={chartKey} />
            </Box>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginLeft: "auto",
                  marginRight: "8px",
                }}
              >
                <TabChartFilter
                  chartFilter={chartFilter}
                  tabHandler={tabHandler}
                />
              </Box>
              <FilterHandler filter={filter} setFilter={setFilter} />
            </Box>
          </Box>
          <Grid container padding={1}>
            {filter && (
              <Fade in={filter} timeout={300}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    padding: "8px",
                    backgroundColor: theme == "light" ? "#E6F1FF" : "#161B25",
                  }}
                >
                  {chartFilter.enum == 0 && (
                    <Grid item xs={12} lg={2} marginRight={"8px"}>
                      <PersianDatePicker
                        year={year}
                        setYear={setYear}
                        month={month}
                        setMonth={setMonth}
                      />
                    </Grid>
                  )}
                  {chartFilter.enum === 1 && (
                    <Grid item lg={2} xs={12}>
                      <YearsDrop year={year} setYear={setYear} />
                    </Grid>
                  )}

                  <Grid
                    item
                    xs={12}
                    lg={2}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "4px",
                    }}
                  >
                    <DySelectBas
                      lable={"نوع "}
                      items={enumsRender(enumsData, "PurchaseInvoiceType")}
                      selectValue={purchaseInvoiceType}
                      setSelectValue={setPurchaseInvoiceType}
                    />

                    <IconButton
                      onClick={() => setPurchaseInvoiceType("")}
                      size="small"
                      sx={{
                        width: 24,
                        height: 24,
                        ml: 1,
                        "&:hover": { backgroundColor: "transparent" },
                      }}
                    >
                      <ClearIcon sx={{ fontSize: 18, color: "red" }} />
                    </IconButton>
                  </Grid>
                </Box>
              </Fade>
            )}
          </Grid>
          <ChartRenderer
            dataLineChart={dataLineChart}
            salseExperts={salseExperts}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0.5rem 0",
            }}
          >
            {deviceType != "mobile" && <TotalChart total={total} size={12} />}
          </Box>
        </>
      ) : (
        <Box
          sx={{
            flexGrow: 1,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            minWidth: 200,
          }}
        >
          <TitleChart label={"کارشناسان فروش"} chartKey={chartKey} />
        </Box>
      )}
    </>
  );
}

export default SalesExpertChart;
